<template>
  <div>
    <responsive-image v-if="hasMedia"
                      :media="product.media[0]"
                      :sizes="['medium', 'large']"
                      :alt="product.name"
                      class="w-24 max-w-order-image object-contain"
    />
    <img v-else
         class="w-24 max-w-order-image object-contain"
         :src="defaultImage"
         :alt="product.name"
    >
  </div>
  <div class="ml-3">
    <p class="text-sm font-bold text-gray-900">{{ product.name }}</p>
    <p class="text-sm text-gray-500">
      {{ description }}
    </p>
    <p v-if="hasModifiers" class="text-sm text-gray-500">
      <template v-for="modifier in variantModifiersList">
        <template v-if="modifier.hasGroup">{{ modifier.group }}: </template>{{ modifier.modifier }}
        <template v-if="modifier.quantity > 1">({{ modifier.quantity }})</template>
        <span class="font-bold text-gray-900"
              v-if="!variant.promotion_reward_id && modifier.total_price !== null && modifier.total_price.value > 0"
        > +{{ modifier.total_price.full }}</span>
        <br>
      </template>
    </p>
    <div class="text-sm text-gray-500 mt-2">
      <template v-if="variant.promotion_reward_id || variant.is_reward">
        <strong class="text-primary">Подарок</strong><br>
        Количество: <strong class="text-gray-900">{{ variantQuantity }} {{ product.unit_type.short_name }}</strong>
      </template>
      <template v-else>
        Цена: <strong class="text-gray-900">{{ variant.original_unit_price.full }}</strong><br>
        Количество: <strong class="text-gray-900">{{ variantQuantity }} {{ product.unit_type.short_name }}</strong><br>
        <template v-if="variant.has_discount">
          Скидка: <strong class="text-gray-900">{{ variant.discount_difference.full }} ({{ variant.discount_percentage.percentage }}%)</strong><br>
        </template>
        Сумма: <strong class="text-gray-900">{{ variant.total_price.full }}</strong>
      </template>
      <template v-if="sku">
        <br>
        Артикул: <strong class="text-gray-900">{{ sku }}</strong>
      </template>
    </div>
  </div>
</template>

<script>
import ResponsiveImage from '@/components/images/ResponsiveImage'
import HasProductVariantDescriptions from '@/mixins/HasProductVariantDescriptions'

export default {
  mixins: [HasProductVariantDescriptions],

  props: {
    variant: {
      required: true,
      type: Object,
    },
  },

  components: {
    ResponsiveImage,
  },

  computed: {
    product() {
      return this.variant.product
    },

    hasMedia() {
      return Array.isArray(this.product.media) && this.product.media.length > 0
    },

    description() {
      return this.getProductVariantDescription(this.variant)
    },

    hasModifiers() {
      return this.hasProductVariantModifiers(this.variant)
    },

    variantModifiers() {
      return this.getProductVariantModifiers(this.variant)
    },

    variantModifiersList() {
      return this.getProductVariantModifiersList(this.variant)
    },

    defaultImage() {
      return require('@/assets/images/product-image-placeholder.jpg')
    },

    sku() {
      if (this.variant.variant && this.variant.variant.sku) {
        return this.variant.variant.sku;
      } else if (this.variant.product && this.variant.product.sku) {
        return this.variant.product.sku;
      }

      return null;
    },

    variantQuantity() {
      if (this.variant.has_measured_quantity) {
        return this.variant.measured_quantity;
      }

      return this.variant.quantity;
    },
  },
}
</script>
